import { ApiClient } from "../utils/ApiClient";

export enum ProductTechnologyEnum {
    Laser = "LASER",
    Punching = "PUNCHING",
    Combined = "COMBINED",
    Bending = "BENDING",
    Software = "SOFTWARE",
    Co2Laser = "CO2LASER",
    SolidStateLaser = "SOLIDSTATELASER",
    MarkingLaser = "MARKINGLASER",
    AquaCut = "AQUACUT",
    Shear = "TRUSHEAR",
    Automation = "AUTOMATION",
    TwoDLaserCutting = "2DLASERCUTTING",
    ThreeDLaserCutting = "3DLASERCUTTING",
    ThreeDPrinting = "3DPRINTING",
    Cooler = "COOLER",
    DiodeLaser = "DIODELASER",
    DiskLaser = "DISKLASER",
    FiberLaser = "FIBERLASER",
    PulsedLaser = "PULSEDLASER",
    Welding = "WELDING",
    ShortPulsedLaser = "SHORTPULSEDLASER",
    StorageSystem = "STORAGESYSTEM",
    LaserTubeCutting = "LASERTUBECUTTING",
    Electronics = "ELECTRONICS"
}

export type ProductTechnologyType = `${ProductTechnologyEnum}`;

export interface ProductType {
    nameOnLabel: string;
    productNo: string;
    technology: ProductTechnologyType;
    dateOfConstruction: string | null;
    locationCity: string | null;
    hasServiceContract: boolean;
    errorSources: string[];
    equipmentType: string;
}

export const getMachineList = async (apiClient: ApiClient): Promise<ProductType[]> => {
    return apiClient.request<ProductType[]>("/servicecall/getproducts", { filterSubEquipments: true }, mockMachines);
};

export const mockMachines: ProductType[] = [
    {
        nameOnLabel: "Quicksharp",
        productNo: "TWDEDEMO097",
        technology: "PUNCHING",
        dateOfConstruction: "2011/01/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "QUICKSHARP"
    },
    {
        nameOnLabel: "TruPunch 5000 Mittelformat",
        productNo: "TWDEDEMO008",
        technology: "PUNCHING",
        dateOfConstruction: "2007/11/09",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "PU50001300"
    },
    {
        nameOnLabel: "TRUMATIC 600 L (Mittelformat)",
        productNo: "TWDEDEMO003",
        technology: "COMBINED",
        dateOfConstruction: "2000/08/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TC600L1300"
    },
    {
        nameOnLabel: "TruMatic 7000 Gro\u00dfformat",
        productNo: "TWDEDEMO009",
        technology: "COMBINED",
        dateOfConstruction: "2011/06/20",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "MA70001600"
    },
    {
        nameOnLabel: "BendMaster bis 60 kg Traglast",
        productNo: "TWDEDEMO025",
        technology: "BENDING",
        dateOfConstruction: "2004/09/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BEMA60"
    },
    {
        nameOnLabel: "TruBend 5050",
        productNo: "TWDEDEMO028",
        technology: "BENDING",
        dateOfConstruction: "2007/12/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5050"
    },
    {
        nameOnLabel: "TruBend 5050",
        productNo: "TWDEDEMO027",
        technology: "BENDING",
        dateOfConstruction: "2007/05/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5050"
    },
    {
        nameOnLabel: "TruBend 5085 (B23)",
        productNo: "TWDEDEMO075",
        technology: "BENDING",
        dateOfConstruction: "2016/02/12",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5085SX23"
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO074",
        technology: "BENDING",
        dateOfConstruction: "2017/06/27",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5130X_23"
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO033",
        technology: "BENDING",
        dateOfConstruction: "2015/04/27",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5130X_23"
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO024",
        technology: "BENDING",
        dateOfConstruction: "2007/01/04",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5130X"
    },
    {
        nameOnLabel: "TruBend 5170",
        productNo: "TWDEDEMO093",
        technology: "BENDING",
        dateOfConstruction: "2019/05/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5170_23"
    },
    {
        nameOnLabel: "TruBend 5170",
        productNo: "TWDEDEMO029",
        technology: "BENDING",
        dateOfConstruction: "2007/05/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5170"
    },
    {
        nameOnLabel: "TruBend 5230 (B23)",
        productNo: "TWDEDEMO069",
        technology: "BENDING",
        dateOfConstruction: "2015/09/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5230_23"
    },
    {
        nameOnLabel: "TruBend 5320 (B23)",
        productNo: "TWDEDEMO071",
        technology: "BENDING",
        dateOfConstruction: "2015/02/19",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE5320_23"
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO077",
        technology: "BENDING",
        dateOfConstruction: "2017/10/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036"
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO076",
        technology: "BENDING",
        dateOfConstruction: "2017/10/10",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036"
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO032",
        technology: "BENDING",
        dateOfConstruction: "2009/06/08",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036"
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO031",
        technology: "BENDING",
        dateOfConstruction: "2009/02/20",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036"
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO030",
        technology: "BENDING",
        dateOfConstruction: "2008/06/23",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036"
    },
    {
        nameOnLabel: "TRUBEND 7050 (B28)",
        productNo: "TWDEDEMO095",
        technology: "BENDING",
        dateOfConstruction: "2019/10/22",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7050_28"
    },
    {
        nameOnLabel: "TruBend Cell 7000 mit BendMaster (15)",
        productNo: "TWDEDEMO026",
        technology: "BENDING",
        dateOfConstruction: "2015/02/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "BE7036CELL"
    },
    {
        nameOnLabel: "TrumaBend E 35",
        productNo: "TWDEDEMO007",
        technology: "BENDING",
        dateOfConstruction: "2001/11/02",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "TRBE35"
    },
    {
        nameOnLabel: "TrumaBend V 320",
        productNo: "TWDEDEMO006",
        technology: "BENDING",
        dateOfConstruction: "1999/07/14",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "TRBV320X"
    },
    {
        nameOnLabel: "TrumaBend V85",
        productNo: "TWDEDEMO004",
        technology: "BENDING",
        dateOfConstruction: "1997/10/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "TRBV85"
    },
    {
        nameOnLabel: "TrumaBend V85SX",
        productNo: "TWDEDEMO005",
        technology: "BENDING",
        dateOfConstruction: "1998/11/05",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"],
        equipmentType: "TRBV85SX"
    },
    {
        nameOnLabel: "Vector Mark Compact 5",
        productNo: "TWDEDEMO043",
        technology: "MARKINGLASER",
        dateOfConstruction: "2009/11/25",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "VMC5A"
    },
    {
        nameOnLabel: "VectorMark compact 1",
        productNo: "TWDEDEMO041",
        technology: "MARKINGLASER",
        dateOfConstruction: "2006/09/08",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "VMC1A"
    },
    {
        nameOnLabel: "VectorMark compact 1",
        productNo: "TWDEDEMO054",
        technology: "MARKINGLASER",
        dateOfConstruction: "1997/06/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "VM1"
    },
    {
        nameOnLabel: "TruLaser 3030",
        productNo: "TWDEDEMO023",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2013/01/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA3030_L20"
    },
    {
        nameOnLabel: "TruLaser 3030 fiber",
        productNo: "TWDEDEMO078",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2018/01/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA3030_L49"
    },
    {
        nameOnLabel: "TruLaser 3030 fiber",
        productNo: "TWDEDEMO073",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2017/06/12",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA3030_L49"
    },
    {
        nameOnLabel: "TruLaser 5030",
        productNo: "TWDEDEMO011",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2007/02/05",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA5030"
    },
    {
        nameOnLabel: "TruLaser 5030 fiber",
        productNo: "TWDEDEMO063",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2015/10/02",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA5030_L68"
    },
    {
        nameOnLabel: "TruLaser 5030 fiber",
        productNo: "TWDEDEMO067",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2011/05/20",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA5030_L41"
    },
    {
        nameOnLabel: "TruLaser 5030 fiber",
        productNo: "TWDEDEMO012",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2010/05/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA5030_L41"
    },
    {
        nameOnLabel: "TruLaser 5030 fiber (L76)",
        productNo: "TWDEDEMO085",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2018/03/29",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LA5030_L76"
    },
    {
        nameOnLabel: "TruLaser Center 7030 (L26)",
        productNo: "TWDEDEMO100",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2020/04/09",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LC7030_L26"
    },
    {
        nameOnLabel: "TruLaser Center 7030 (L26)",
        productNo: "TWDEDEMO068",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2016/06/06",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LC7030_L26"
    },
    {
        nameOnLabel: "TRUMATIC L 3050",
        productNo: "TWDEDEMO010",
        technology: "2DLASERCUTTING",
        dateOfConstruction: "2001/09/24",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TCL3050"
    },
    {
        nameOnLabel: "TRUMATIC L 3050",
        productNo: "TWDEDEMO064",
        technology: "2DLASERCUTTING",
        dateOfConstruction: null,
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TCL3050"
    },
    {
        nameOnLabel: "TruLaser Cell 7040",
        productNo: "TWDEDEMO088",
        technology: "3DLASERCUTTING",
        dateOfConstruction: "2019/04/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LACE7040F"
    },
    {
        nameOnLabel: "TruLaser Cell 7040",
        productNo: "TWDEDEMO087",
        technology: "3DLASERCUTTING",
        dateOfConstruction: "2019/03/06",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LACE7040"
    },
    {
        nameOnLabel: "TRUMPF LASERCELL 1005",
        productNo: "TWDEDEMO090",
        technology: "3DLASERCUTTING",
        dateOfConstruction: "2008/08/27",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TLC1005"
    },
    {
        nameOnLabel: "TRUMPF LASERCELL 1005",
        productNo: "TWDEDEMO013",
        technology: "3DLASERCUTTING",
        dateOfConstruction: "2007/05/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TLC1005"
    },
    {
        nameOnLabel: "TruPrint 1000",
        productNo: "TWDEDEMO089",
        technology: "3DPRINTING",
        dateOfConstruction: "2018/05/14",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["AM_HMI", "AM_DESKTOP", "AM_TITP"],
        equipmentType: "PR1000"
    },
    {
        nameOnLabel: "TruPrint 3000",
        productNo: "TWDEDEMO096",
        technology: "3DPRINTING",
        dateOfConstruction: "2019/09/06",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["AM_HMI", "AM_DESKTOP", "AM_TITP"],
        equipmentType: "PR3000"
    },
    {
        nameOnLabel: "TruDiode 3006 (FD26)",
        productNo: "TWDEDEMO092",
        technology: "DIODELASER",
        dateOfConstruction: "2018/05/07",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "DIO3006F26"
    },
    {
        nameOnLabel: "TruDisk 2001",
        productNo: "TWDEDEMO066",
        technology: "DISKLASER",
        dateOfConstruction: "2009/12/15",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "DI2001_4C"
    },
    {
        nameOnLabel: "TruDisk 3001",
        productNo: "TWDEDEMO048",
        technology: "DISKLASER",
        dateOfConstruction: "2010/06/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "DI3001_4C"
    },
    {
        nameOnLabel: "TruDisk 4002",
        productNo: "TWDEDEMO050",
        technology: "DISKLASER",
        dateOfConstruction: "2011/11/28",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "DI4002_4C"
    },
    {
        nameOnLabel: "TruDisk 8002",
        productNo: "TWDEDEMO070",
        technology: "DISKLASER",
        dateOfConstruction: "2016/05/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "DI8002_4C"
    },
    {
        nameOnLabel: "HL 101 P",
        productNo: "TWDEDEMO040",
        technology: "PULSEDLASER",
        dateOfConstruction: "2005/06/15",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL101P"
    },
    {
        nameOnLabel: "HL 2006 D",
        productNo: "TWDEDEMO056",
        technology: "PULSEDLASER",
        dateOfConstruction: "2000/02/17",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL2006D"
    },
    {
        nameOnLabel: "HL 2006 D",
        productNo: "TWDEDEMO053",
        technology: "PULSEDLASER",
        dateOfConstruction: "1996/03/08",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL2006D"
    },
    {
        nameOnLabel: "HL 3006 D",
        productNo: "TWDEDEMO057",
        technology: "PULSEDLASER",
        dateOfConstruction: "2005/09/19",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL3006D"
    },
    {
        nameOnLabel: "HL 4006 D",
        productNo: "TWDEDEMO058",
        technology: "PULSEDLASER",
        dateOfConstruction: "2005/06/10",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL4006D"
    },
    {
        nameOnLabel: "HL 54 P",
        productNo: "TWDEDEMO055",
        technology: "PULSEDLASER",
        dateOfConstruction: "1997/06/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"],
        equipmentType: "HL54P"
    },
    {
        nameOnLabel: "TruLaser Cell 3000",
        productNo: "TWDEDEMO062",
        technology: "WELDING",
        dateOfConstruction: "2015/09/25",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LACE3000"
    },
    {
        nameOnLabel: "TruLaser Cell 3309",
        productNo: "TWDEDEMO042",
        technology: "WELDING",
        dateOfConstruction: "2006/02/02",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LACE3309"
    },
    {
        nameOnLabel: "TruLaser Station 5010",
        productNo: "TWDEDEMO044",
        technology: "WELDING",
        dateOfConstruction: "2011/03/23",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LAST5010"
    },
    {
        nameOnLabel: "TruLaser Station 5010",
        productNo: "TWDEDEMO046",
        technology: "WELDING",
        dateOfConstruction: "2008/02/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LAST5010"
    },
    {
        nameOnLabel: "TrumaWeld L 1000",
        productNo: "TWDEDEMO017",
        technology: "WELDING",
        dateOfConstruction: "2004/05/01",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "TWL1000"
    },
    {
        nameOnLabel: "TruLaser Robot 5020",
        productNo: "TWDEDEMO016",
        technology: "LASERTUBECUTTING",
        dateOfConstruction: "2008/06/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LARO5020"
    },
    {
        nameOnLabel: "TruLaser Robot 5020",
        productNo: "TWDEDEMO060",
        technology: "LASERTUBECUTTING",
        dateOfConstruction: "2007/11/02",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LARO5020"
    },
    {
        nameOnLabel: "TruLaser Tube 5000 T06 fiber",
        productNo: "TWDEDEMO072",
        technology: "LASERTUBECUTTING",
        dateOfConstruction: "2015/05/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LATU500006"
    },
    {
        nameOnLabel: "TruLaser Tube 7000",
        productNo: "TWDEDEMO014",
        technology: "LASERTUBECUTTING",
        dateOfConstruction: "2012/05/22",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LATU700002"
    },
    {
        nameOnLabel: "TruLaser Tube 7000 (T07) fiber",
        productNo: "TWDEDEMO098",
        technology: "LASERTUBECUTTING",
        dateOfConstruction: "2019/11/21",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"],
        equipmentType: "LATU700007"
    }
];
